<div class="outer">
  <div class="button">
    <p class="label">
      View Cart
    </p>
    <p class="counter">
      ({{itemCount()}})
    </p>
  </div>
</div> 